const Selectors = {};
class cartJS {
    constructor() {
        this.init();
    }

    async init(){
        const cart = window.globalVariables.cart;
        this._changeProductOnCart(cart);
        this._freeSticker(cart);

        // let stateCheck = setInterval(() => {
        //     if (document.readyState === 'complete') {
        //         setTimeout(() => {
        //             //document.querySelector('cart-action-btn a[name=checkout]').setAttribute('disabled',false);
        //             document.querySelector('.cart-action-btn a[name="checkout"]').textContent = 'Secure Checkout';
        //             document.querySelector('.cart-action-btn').classList.remove("disabled");
        //         }, 1000);
        //         clearInterval(stateCheck);
        //     }
        // }, 10);
    }

    addStickerProduct(toadd) {
        if (toadd.length) {
            fetch('/cart/add.js', {
                body: JSON.stringify({items: toadd}),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With':'xmlhttprequest'
                },
                method: 'POST'
            }).then((response) => {
                document.querySelector('ajax-cart').getCartData();
                //location.reload();
            }).catch((err) => {
                /* uh oh, we have error. */
                console.error(err);
            });
        }
    }

    removeStickerProduct(toadd) {

        if (Object.keys(toadd).length > 0) {
            fetch('/cart/update.js', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({ updates: toadd })
            }).then((response) => {
                document.querySelector('ajax-cart').getCartData();
                //location.reload();
            }).catch((err) => {
                /* uh oh, we have error. */
                console.error(err);
            });
        }
    }

    _freeSticker(cart){
        const regularFreeGift_variantID =  window.globalVariables.ProductFreeStickerID;

        let $this = this;
        let startDate = new Date(window.globalVariables.StartDate+' '+window.globalVariables.StartTime);
        var endDate= new Date(window.globalVariables.EndDate+' '+window.globalVariables.EndTime);
        var today= new Date();
        let $regularGift_flag = false;

        /* Start scent variable */
        let addSticker = new Array();
        let removeSticker = {};
        let scenStickerEnable = window.globalVariables.scentStickerEnable;
        const scenStickerProductID = window.globalVariables.scentStickerProductID;
        let scentPromises = [];
        let scentStickerQuantity = 0;
        let $addScentStickerProductFlag = false;
        let $needTocheckAvailablity = false;
        let $stickerQty;
        /* End scent variable */

        let ChangeFlag = false;
        let dateValid = false;

        if(cart.items.length > 0){
            for(let i=0;i<cart.items.length;i++){
                let promise = new Promise((resolve, reject) => {
                    if(cart.items[i].id == regularFreeGift_variantID){
                        $regularGift_flag = true;
                    }
                    if(scenStickerProductID != undefined){
                        if(cart.items[i].id == scenStickerProductID){
                            $addScentStickerProductFlag = true;
                            $stickerQty = cart.items[i].quantity;
                        }
                        if(scenStickerEnable){
                            let handle = cart.items[i].handle;
                            let itemQuantity = cart.items[i].quantity;

                            fetch(`/products/${handle}.js`, {
                                headers: {
                                    'Content-Type': 'application/json',
                                  },
                                method: 'GET'
                            }).then((response) => {
                                return response.json();
                            }).then((data) => {
                                data.tags.forEach(tag => {
                                    if(tag.search("freeScent_Sticker") == 0 && itemQuantity >= 2){
                                        $needTocheckAvailablity = true;
                                        scentStickerQuantity += itemQuantity
                                    }
                                });
                            }).catch((err) => {
                                /* uh oh, we have error. */
                                console.error(err)
                            });

                        }
                    }
                    resolve();
                });
                scentPromises.push(promise);
            }
        }
        Promise.all(scentPromises).then(function() {
            /* Start Code Free Sticker */
            if(window.globalVariables.productFreeStickerEnable && (today >= startDate && today <= endDate)){
                dateValid = true;
            }
            if($regularGift_flag){
                if(cart.item_count == 1 || dateValid == false){
                    ChangeFlag = true;
                }
            }

            if(!$regularGift_flag && dateValid && cart.item_count > 0 ){
                addSticker.push({
                    id: regularFreeGift_variantID,
                    quantity: 1
                });
            }else if(ChangeFlag){
                removeSticker[regularFreeGift_variantID]=0;
            }
            /* End Code Free Sticker */

            // Start scent Code

            if(!$addScentStickerProductFlag){
                if($needTocheckAvailablity){
                  addSticker.push({
                    id: scenStickerProductID,
                    quantity: 1
                  });
                }
            }else if($addScentStickerProductFlag){
                if(!scenStickerEnable || !$needTocheckAvailablity){
                  scentStickerQuantity = 0
                }else if($needTocheckAvailablity){
                  scentStickerQuantity = Math.floor(scentStickerQuantity / 2)
                }

                if($stickerQty != scentStickerQuantity){
                    removeSticker[scenStickerProductID]=0;
                }
            }
            // End Scent Code
            if(addSticker.length > 0){
                $this.addStickerProduct(addSticker);
            }else if(Object.keys(removeSticker).length > 0) {
                $this.removeStickerProduct(removeSticker);
            }

        }).catch(error =>{
            console.log(error);
        });

    }

    async _changeProductOnCart(response) {
        let subscriptionAvailable = false;

        if(response.items.length > 0){
            for(let i=0;i<response.items.length;i++){
                if((response.items[i].properties && 'subscription_id' in response.items[i].properties) || window.globalVariables.checkActivesubscriber){
                    subscriptionAvailable = true;
                }
            }
            var remove_items = {};
            let productDetails = [];
            let promises = [];
            var cartDetails = [];
            var add_items = [];

            for(let i=0;i<response.items.length;i++){
                let handle = response.items[i].handle;
                let productProperties = false;
                if(response.items[i].properties && 'subscription_id' in response.items[i].properties){
                    productProperties = true;
                }

                if(productProperties == false){
                    let promise = new Promise((resolve, reject) => {
                        fetch(`/products/${handle}.js`, {
                            headers: {
                                'Content-Type': 'application/json',
                              },
                            method: 'GET'
                        }).then((response) => {
                            return response.json();
                        }).then((data) => {
                            data.tags.forEach(tag => {
                                if(tag.search("OneTimeDiscount") == 0){
                                  cartDetails.push(response.items[i]);
                                  productDetails.push(data);
                                  return;
                                }
                            });
                            resolve();
                        }).catch((err) => {
                            /* uh oh, we have error. */
                            console.error(err);
                            reject();
                        });
                    });
                    promises.push(promise);
                }
            }

            Promise.all(promises).then(function() {

                cartDetails.forEach(cartDetail => {
                  productDetails.forEach(productDetail => {
                    if (productDetail.id === cartDetail.product_id) {

                      productDetail.variants.forEach(productVariant => {
                      if(!subscriptionAvailable){
                        if (productVariant.title + ' - Club Discount' === cartDetail.variant_title) {
                          add_items.push({
                            id: parseInt(productVariant.id),
                            quantity: parseInt(cartDetail.quantity),
                          });
                          remove_items[cartDetail.id]=0;
                        }
                      }else if(subscriptionAvailable){
                        if(cartDetail.variant_title == null){cartDetail.variant_title = "Default Title";}
                        if (cartDetail.variant_title + ' - Club Discount' === productVariant.title) {
                          add_items.push({
                            id: parseInt(productVariant.id),
                            quantity: parseInt(cartDetail.quantity),
                          });
                          remove_items[cartDetail.id]=0;
                        }
                      }
                      });
                    }
                  });
                });

                if (Object.keys(remove_items).length > 0) {
                    fetch('/cart/update.js', {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json"
                        },
                        body: JSON.stringify({
                            updates: remove_items
                        })
                    }).then((response) => {
                        fetch('/cart/add.js', {
                            body: JSON.stringify({items: add_items}),
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With':'xmlhttprequest'
                            },
                            method: 'POST'
                        }).then((response) => {
                            document.querySelector('ajax-cart').getCartData();
                            // location.reload();
                        }).catch((err) => {
                            /* uh oh, we have error. */
                            console.error(err);
                        });
                    })
                    .catch((err) => {
                        /* uh oh, we have error. */
                        console.error(err);
                    });

                }

            }).catch(error =>{
                console.log(error);
            });

        }
    }

}

// typeof cartJS !== 'undefined' && new cartJS();
var cartPageJS = new cartJS();
